import { createContext } from 'preact'
import { useState, useContext } from 'preact/hooks'
import { useOmneoClient } from '../hooks/useOmneoClient'

export const ON_BOARDING_STATES = {
  INIT: 0,
  ABOUT: 1,
  AVATAR: 2,
  SPORTS: 3,
  BRANDS: 4,
  CONFIRMATION: 5
}
export const CHILD_PROFILE_ACTIONS = {
  ADD: 'ADD',
  EDIT: 'EDIT'
}

const ChildProfileOnBoardingDataStructure = {
  child: {
    id: 0,
    steps: [
      {
        firstName: '',
        lastName: '',
        birthday: '',
        gender: '',
        shoeTag: ''
      },
      {
        value: '',
        url: ''
      },
      {
        sports: [{ value: '', id: '' }]
      },
      {
        brands: [{ value: '', id: '' }]
      }
    ]
  }
}
const ChildrenProfilesDataStructure = [ChildProfileOnBoardingDataStructure]

/** Init DataStructure for onboarding  */
const LoyaltyOnBoardingConfigDataStructure = {
  currentState: ON_BOARDING_STATES.INIT,
  currentChild: 0,
  childrenProfiles: ChildrenProfilesDataStructure
}

const OnBoardingContext = createContext({})

/** LoyaltyOnBoardingContext hook */
/**
 *
 * Note
 * For some reason Preact will not let me change the name of this context
 * without throwing some weird error. It seems to only work when i have it
 * set to use useMobileFiltersContext name.
 *
 *
 * @returns
 */
export const useMobileFiltersContext = () => {
  const {
    config,
    setConfig,
    handleNextStep,
    handleUpdateConfig,
    getCurrentChild,
    handleNewChildProfile,
    setCurrentChild,
    setChildCreated,
    omneoClient
  } = useContext(OnBoardingContext)
  return {
    config,
    setConfig,
    handleNextStep,
    handleUpdateConfig,
    getCurrentChild,
    handleNewChildProfile,
    setCurrentChild,
    setChildCreated,
    omneoClient
  }
}

/**
 *
 * On boarding loyalty provider
 *
 * @param {*} param0
 * @returns
 */
export function LoyaltyOnBoardingContext({ children }) {
  const [config, setConfig] = useState(LoyaltyOnBoardingConfigDataStructure)
  const { client } = useOmneoClient()

  const getCurrentChild = () => {
    const index = config.currentChild
    const childrenProfiles = config.childrenProfiles
    return childrenProfiles[index].child
  }

  /** Used when a successful form submit is saved we set the child's information in state */
  const handleUpdateConfig = (input) => {
    setConfig((c) => {
      const tmpConfig = { ...c }
      const { currentChild, currentState, childrenProfiles } = tmpConfig
      const currentChildProfile = childrenProfiles[currentChild]?.child
      currentChildProfile.steps[currentState - 1] = input
      return tmpConfig
    })
  }

  const handleNewChildProfile = () => {
    const tmp = {
      child: {
        id: 0,
        connectionId: 0,
        steps: [
          {
            firstName: '',
            lastName: '',
            birthday: '',
            gender: '',
            shoeTag: ''
          },
          {
            value: '',
            url: ''
          },
          {
            sports: []
          },
          {
            brands: []
          }
        ]
      }
    }
    tmp.child.id = config.childrenProfiles.length
    setConfig((c) => {
      const tmpConfig = { ...c }
      tmpConfig.childrenProfiles.push(tmp)
      tmpConfig.currentChild = tmp.child.id
      return tmpConfig
    })
    handleNextStep(ON_BOARDING_STATES.ABOUT)
  }

  const setCurrentChild = (id) => setConfig((c) => ({ ...c, currentChild: id }))

  const setChildCreated = (id) =>
    setConfig((c) => {
      const childrenProfiles = c.childrenProfiles.map((c) => {
        if (c.child.id === id) {
          c.child.created = true
        }
        return c
      })
      return { ...c, childrenProfiles }
    })

  /**
   * Handles the pushing the user to the next step on the on-boarding process
   * @param {*} step
   */
  const handleNextStep = (step) => {
    setConfig((c) => ({ ...c, currentState: step }))
  }

  return (
    <OnBoardingContext.Provider
      value={{
        config,
        setConfig,
        handleNextStep,
        handleUpdateConfig,
        getCurrentChild,
        handleNewChildProfile,
        setCurrentChild,
        setChildCreated,
        omneoClient: client
      }}
    >
      {children}
    </OnBoardingContext.Provider>
  )
}
